import React, { createContext, ReactNode, useContext, useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import UserEngagement from "../UserEngagement/UserEngagement";
import UxScoreButton from "../UxScoreButton/UxScoreButton";

type PageWrapperContextType = {
  isFormModalOpen: boolean;
  changeModalState: (val) => void;
};

const PageWrapperContext = createContext<PageWrapperContextType | undefined>(
  undefined
);

export const PageWrapperProvider = ({ children }: { children: ReactNode }) => {
  const [isFormModalOpen, setIsFormModalOpen] = useState(false);

  const changeModalState = (val) => setIsFormModalOpen(val);

  return (
    <PageWrapperContext.Provider
      value={{
        isFormModalOpen,
        changeModalState,
      }}
    >
      {children}
    </PageWrapperContext.Provider>
  );
};

export const usePageWrapperContext = () => {
  const context = useContext(PageWrapperContext);
  if (!context) {
    throw new Error(
      "usePageWrapperContext must be used within a PageWrapperProvider"
    );
  }
  return context;
};

export default function PageWrapper({
  children,
}: {
  readonly children: React.ReactNode;
}) {
  const [isUxScoreEnabled, setIsFormModalOpen] = useState(false);

  useEffect(() => {
    setIsFormModalOpen(Boolean(localStorage.getItem('disable_ui_ux_form') || false))
  }, [])


  return (
    <PageWrapperProvider>
      {children}
      <ToastContainer />
      {!isUxScoreEnabled && (
        <UxScoreButton />
      )}
      <UserEngagement />
    </PageWrapperProvider>
  );
}
